<template>
  <div style="background-color: #f5f5f5;">
    <Topo />
    <b-container>
      <h3 class="mb-4 text-center"><b><u>Meus Dados</u></b></h3>
      <div class="row">
        <div class="col-md-3 mb-3">
          <Menu />
        </div>
        <div class="col-md-9">
          <b-form @submit="onSubmit">
            <b-card header-tag="header">
              <template v-slot:header>
                <div class="float-left">Dados Pessoais</div>
                <div class="float-right">
                  <b-button class="mr-2" type="submit" variant="success" size="sm" v-if="edicao">
                    <b-spinner v-show="trabalhando" small class="mr-2"></b-spinner>
                    <span v-if="trabalhando">Trabalhando...</span>
                    <span v-else>Salvar</span>
                  </b-button>
                  <!-- <b-button :variant="edicao ? 'danger': 'primary'" size="sm" @click="edicao=!edicao">{{edicao ? 'Cancelar' : 'Alterar'}}</b-button> -->
                  <b-button disabled="true" variant="primary" v-if="!edicao" size="sm" @click="edicao=true">Alterar</b-button>
                  <b-button variant="danger" v-else size="sm" @click="Cancelar()">Cancelar</b-button>
                </div>
              </template>
              <div class="row">
                <div class="col-md-9">
                  <b-form-group label="Nome" label-for="nome">
                    <b-form-input id="nome"  maxlength="80" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.nome.$model"
                      :state="$v.form.nome.$dirty ? !$v.form.nome.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">
                      <div v-if="!$v.form.nome.required">Campo obrigatório</div>
                      <div v-if="!$v.form.nome.minLength">Mínimo de 10 caracteres</div>
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="CPF" label-for="cpf">
                    <b-form-input id="cpf" size="sm" v-model="form.cpf" class="text-center" style="max-width: 9rem;" readonly></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Nome para credencial" label-for="cracha">
                    <b-form-input id="cracha" maxlength="20" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.cracha.$model"
                      :state="$v.form.cracha.$dirty ? !$v.form.cracha.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Especialidade" label-for="especialidade">
                    <b-form-select size="sm" v-model="$v.form.id_profissao.$model" :disabled="!edicao"
                      :state="$v.form.id_profissao.$dirty ? !$v.form.id_profissao.$error : null"
                      aria-describedby="input-1-live-feedback">
                      <option :value="null"></option>
                      <option :key="especialidade.id" v-for="especialidade in especialidades" :value="especialidade.id">{{especialidade.nome}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="CRM" label-for="crm">
                    <b-form-input id="crm" maxlength="20" size="sm" :readonly="!edicao"
                      v-model.trim="form.crm">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="UF" label-for="uf">
                    <b-form-select size="sm" :disabled="!edicao"
                      v-model.trim="form.ufcrm">
                      <option value></option>
                      <option value="AC">AC</option>
                      <option value="AL">AL</option>
                      <option value="AM">AM</option>
                      <option value="AP">AP</option>
                      <option value="BA">BA</option>
                      <option value="CE">CE</option>
                      <option value="DF">DF</option>
                      <option value="ES">ES</option>
                      <option value="GO">GO</option>
                      <option value="MA">MA</option>
                      <option value="MG">MG</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="PA">PA</option>
                      <option value="PB">PB</option>
                      <option value="PE">PE</option>
                      <option value="PI">PI</option>
                      <option value="PR">PR</option>
                      <option value="RJ">RJ</option>
                      <option value="RN">RN</option>
                      <option value="RO">RO</option>
                      <option value="RR">RR</option>
                      <option value="RS">RS</option>
                      <option value="SC">SC</option>
                      <option value="SE">SE</option>
                      <option value="SP">SP</option>
                      <option value="TO">TO</option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
            </b-card>

            <b-card header="Endereço" class="mt-3 mb-4">
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="CEP" label-for="cep">
                    <b-form-input id="cep" v-mask="'##.###-###'" v-on:keyup="BuscaCep()" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.cep.$model"
                      :state="$v.form.cep.$dirty ? !$v.form.cep.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Endereço" label-for="endereco">
                    <b-form-input id="endereco" ref="endereco" maxlength="80" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.endereco.$model"
                      :state="$v.form.endereco.$dirty ? !$v.form.endereco.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="Número" label-for="numero">
                    <b-form-input id="numero" ref="numero" maxlength="10" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.numero.$model"
                      :state="$v.form.numero.$dirty ? !$v.form.numero.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Complemento" label-for="complemento">
                    <b-form-input id="complemento" v-model="form.complemento" maxlength="50" size="sm" :readonly="!edicao"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <b-form-group label="Bairro" label-for="bairro">
                    <b-form-input id="bairro" maxlength="50" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.bairro.$model"
                      :state="$v.form.bairro.$dirty ? !$v.form.bairro.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-5">
                  <b-form-group label="Cidade" label-for="cidade">
                    <b-form-input id="cidade" maxlength="50" size="sm" :readonly="!edicao"
                      v-model.trim="$v.form.cidade.$model"
                      :state="$v.form.cidade.$dirty ? !$v.form.cidade.$error : null"
                      aria-describedby="input-1-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="UF" label-for="uf">
                    <b-form-select size="sm" :disabled="!edicao"
                      v-model.trim="$v.form.uf.$model"
                      :state="$v.form.uf.$dirty ? !$v.form.uf.$error : null"
                      aria-describedby="input-1-live-feedback">
                      <option value></option>
                      <option value="AC">AC</option>
                      <option value="AL">AL</option>
                      <option value="AM">AM</option>
                      <option value="AP">AP</option>
                      <option value="BA">BA</option>
                      <option value="CE">CE</option>
                      <option value="DF">DF</option>
                      <option value="ES">ES</option>
                      <option value="GO">GO</option>
                      <option value="MA">MA</option>
                      <option value="MG">MG</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="PA">PA</option>
                      <option value="PB">PB</option>
                      <option value="PE">PE</option>
                      <option value="PI">PI</option>
                      <option value="PR">PR</option>
                      <option value="RJ">RJ</option>
                      <option value="RN">RN</option>
                      <option value="RO">RO</option>
                      <option value="RR">RR</option>
                      <option value="RS">RS</option>
                      <option value="SC">SC</option>
                      <option value="SE">SE</option>
                      <option value="SP">SP</option>
                      <option value="TO">TO</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Telefone 01" label-for="telefone_pref">
                    <table>
                      <tr>
                        <td class="text-right">
                          <b-form-input id="telefone_pref" maxlength="2" class="preftel" size="sm" :readonly="!edicao"
                            v-model.trim="$v.form.telefone_pref.$model"
                            :state="$v.form.telefone_pref.$dirty ? !$v.form.telefone_pref.$error : null"
                            aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">*</b-form-invalid-feedback>
                        </td>
                        <td>
                          <b-form-input id="telefone" maxlength="10" class="tel" size="sm" :readonly="!edicao"
                            v-model.trim="$v.form.telefone.$model"
                            :state="$v.form.telefone.$dirty ? !$v.form.telefone.$error : null"
                            aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">
                            <div v-if="!$v.form.telefone.required">Campo obrigatório</div>
                            <div v-if="!$v.form.telefone.minLength">Mínimo de 8 dígitos</div>
                          </b-form-invalid-feedback>
                        </td>
                      </tr>
                    </table>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Telefone 02" label-for="fax_pref">
                    <table>
                      <tr>
                        <td>
                          <b-form-input id="fax_pref" v-model="form.fax_pref" maxlength="2" class="preftel" size="sm" :readonly="!edicao"></b-form-input>
                        </td>
                        <td>
                          <b-form-input id="fax" v-model="form.fax" maxlength="10" class="tel" size="sm" :readonly="!edicao"></b-form-input>
                        </td>
                      </tr>
                    </table>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Telefone 03" label-for="celular_pref">
                    <table>
                      <tr>
                        <td>
                          <b-form-input
                            id="celular_pref" v-model="form.celular_pref" maxlength="2" class="preftel" size="sm" :readonly="!edicao"></b-form-input>
                        </td>
                        <td>
                          <b-form-input
                            id="celular" v-model="form.celular" maxlength="10" class="tel" size="sm" :readonly="!edicao"></b-form-input>
                        </td>
                      </tr>
                    </table>
                  </b-form-group>
                </div>
              </div>
            </b-card>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'
import Menu from '@/components/Menu.vue'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Dados',
  computed: mapState(['user']),
  mixins: [validationMixin],
  components: { Topo, Menu },
  data () {
    return {
      edicao: false,
      trabalhando: false,
      especialidades: [],
      form: {},
      naoLocalizadoRes: false
    }
  },
  validations () {
    return {
      form: {
        nome: {
          required,
          minLength: minLength(10)
        },
        cracha: { required },
        id_profissao: { required },
        cep: { required },
        endereco: { required },
        numero: { required },
        bairro: { required },
        cidade: { required },
        uf: { required },
        telefone_pref: { required },
        telefone: {
          required,
          minLength: minLength(8)
        }
      }
    }
  },
  methods: {
    ValidaNome () {
      return this.form.nome.length >= this.form.cracha.length
    },
    BuscaCep (VCep) {
      const teclas = ['Shift', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']
      if (teclas.includes(event.key)) return
      this.naoLocalizadoRes = false
      let cep = ''

      if (this.form.cep.length === 10) {
        cep = this.form.cep.replace(/[^\d]+/g, '')
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then(endereco => {
            if (endereco.erro) {
              this.form.endereco = ''
              this.form.numero = ''
              this.form.bairro = ''
              this.form.complemento = ''
              this.form.cidade = ''
              this.form.uf = ''
              this.$refs.endereco.focus()
              this.naoLocalizadoRes = true
              return
            }
            this.form.endereco = endereco.data.logradouro
            this.form.numero = ''
            this.form.bairro = endereco.data.bairro
            this.form.complemento = ''
            this.form.cidade = endereco.data.localidade
            this.form.uf = endereco.data.uf
            this.$refs.numero.focus()
          })
      }
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.global.defaultError({ msg: 'Por favor, verifique os erros no formulário' })
      } else {
        if (this.ValidaNome()) {
          if (this.user.id_categoria < 9 && (!this.form.crm || !this.form.ufcrm)) {
            this.$toasted.global.defaultError({ msg: 'Por favor, informe o CRM e a UF do CRM' })
          } else {
            this.SalvaRegistro()
          }
        } else {
          this.$toasted.global.defaultError({ msg: 'Nome completo não pode ser menor do que o nome para a credencial' })
        }
      }
    },
    Cancelar () {
      this.edicao = false
      this.CarregaDadosParticipante()
    },
    SalvaRegistro () {
      this.trabalhando = true
      axios.put(`${baseApiUrl}/ficha/salvar`, this.form)
        .then(() => {
          this.edicao = false
          this.trabalhando = false
          // console.log('trabalhando = false...')
        })
        .catch(err => {
          showError(err)
          this.trabalhando = false
        })
    },
    CarregaDados () {
      const url = `${baseApiUrl}/profissoes`
      axios.get(url)
        .then(res => {
          this.especialidades = res.data
          // console.log('chama carga de dados do participante')
          this.CarregaDadosParticipante()
        })
        .catch(err => {
          showError(err)
        })
    },
    CarregaDadosParticipante () {
      // console.log('carregando dados...')
      const url = `${baseApiUrl}/ficha/participante/${this.user.id}`
      // console.log(`Chama API ${url}`)
      axios.get(url)
        .then(res => {
          // console.log('Carregou dados do participante')
          this.form = res.data
        })
        .catch(err => {
          showError(err)
        })
    }
  },
  // watch: {
  //   edicao () {
  //     console.log('editando...')
  //     if (!this.edicao && !this.trabalhando) {
  //       this.CarregaDadosParticipante()
  //     }
  //   }
  // },
  mounted () {
    this.CarregaDados()
  }
}
</script>

<style scoped>
  .preftel {
    display: float-left;
    max-width: 60px;
  }
  .tel {
    display: float-left;
    max-width: 120px;
  }
</style>
